import { Injectable } from '@angular/core';
import { SecurityService } from './security.service';
import { AppSettings } from 'src/config/app-setting';

@Injectable({
  providedIn: 'root'
})
export class TokenUpdaterService {
  private expirationDate: number = 0;

  constructor(private securityService: SecurityService) {
  }

  startTokenRefresh() {
    setInterval(() => {
      // console.log('SecurityService: setInterval(...)');
      if (this.isTokenExpiring()) {
        this.refreshToken();
      }
    }, AppSettings.TokenUpdater.checkingFrequencyMilliseconds);
  }

  isTokenExpiring() {
    // console.log('isTokenExpiring()')

    this.expirationDate = this.securityService.GetTokenExpirationDate();

    if (this.expirationDate == 0 || this.expirationDate < Date.now())
    {
      // console.log('SetUserNotLogged because this.expirationDate == 0 || this.expirationDate < Date.now()')
      this.securityService.SetUserNotLogged();
      this.securityService.loginChangedEventEmitter.emit(true);
      return false; // Non sta scadendo in quanto non sono loggato.
    }

    // console.log('SecurityService: "return (this.expirationDate - Date.now()) < AppSettings.checkingFrequencyMilliseconds;"');
    return (this.expirationDate - Date.now()) < AppSettings.TokenUpdater.refreshThresholdMilliseconds;
  }

  refreshToken() {
    // console.log('execute this.securityService.UserRefreshToken()');
    this.securityService.UserRefreshToken();
    // console.log('this.securityService.UserRefreshToken()')
  }

}
